export default class PageNamespace
{

}
